/* Tribo Nerd — cinematic scroll home engine.
   Mobile-first: canvas frame sequence. Desktop: blob video scrub.
   Isolated: IIFE, tn- namespace, survives shopify:section:load/unload. */
(function () {
  'use strict';

  var instances = {};

  /* seeded rng so "random" scatter offsets are identical on every load */
  function rng(seed) {
    var s = seed >>> 0;
    return function () { s = (s * 1664525 + 1013904223) >>> 0; return s / 4294967296; };
  }

  function smoothstep(p, e0, e1) {
    var t = Math.min(1, Math.max(0, (p - e0) / (e1 - e0)));
    return t * t * (3 - 2 * t);
  }
  function clamp(v, lo, hi) { return Math.min(hi, Math.max(lo, v)); }

  /* split band text into word/char spans, aria-safe, seeded jitter */
  function splitBand(band, seedBase) {
    var lines = band.querySelectorAll('[data-tn-split]');
    var rand = rng(seedBase);
    lines.forEach(function (el) {
      if (el.dataset.tnSplitDone) return;
      el.dataset.tnSplitDone = '1';
      var text = el.textContent;
      var sr = document.createElement('span');
      sr.className = 'tn-sr';
      sr.textContent = text;
      var vis = document.createElement('span');
      vis.setAttribute('aria-hidden', 'true');
      var mode = band.dataset.fx;
      var words = text.split(' ');
      var total = Math.max(1, text.replace(/ /g, '').length);
      var charIndex = 0;
      words.forEach(function (word, wi) {
        var w = document.createElement('span');
        w.className = 'tn-w';
        if (el.dataset.tnEm && word.replace(/[.,!?]/g, '').toLowerCase() === el.dataset.tnEm.toLowerCase()) w.classList.add('tn-em');
        if (mode === 'scatter') {
          for (var i = 0; i < word.length; i++) {
            var c = document.createElement('span');
            c.className = 'tn-c';
            c.textContent = word[i];
            c.style.setProperty('--tn-th', (rand() * 0.55).toFixed(3));
            c.style.setProperty('--tn-jx', ((rand() - 0.5) * 46).toFixed(1) + 'px');
            c.style.setProperty('--tn-jy', ((rand() - 0.5) * 40).toFixed(1) + 'px');
            c.style.setProperty('--tn-jr', ((rand() - 0.5) * 24).toFixed(1) + 'deg');
            w.appendChild(c);
            charIndex++;
          }
        } else {
          w.textContent = word;
          var th = (mode === 'rise' || mode === 'drift') ? (wi / Math.max(1, words.length) * 0.45) : (charIndex / total * 0.4 + rand() * 0.06);
          w.style.setProperty('--tn-th', th.toFixed(3));
          charIndex += word.length;
        }
        vis.appendChild(w);
        if (wi < words.length - 1) vis.appendChild(document.createTextNode(' '));
      });
      el.textContent = '';
      el.appendChild(sr);
      el.appendChild(vis);
    });
  }

  function makeChevron() {
    var d = document.createElement('div');
    d.setAttribute('aria-hidden', 'true');
    d.style.cssText = 'position:absolute;right:22px;bottom:20px;width:14px;height:14px;border-right:2px solid currentColor;border-bottom:2px solid currentColor;transform:rotate(45deg);opacity:.7;color:#b9aed2';
    return d;
  }

  function initSection(container) {
    var root = container.querySelector('[data-tn-hero-root]');
    if (!root || root.dataset.tnInit) return;
    root.dataset.tnInit = '1';

    var cfg = JSON.parse(container.querySelector('[data-tn-config]').textContent);
    var hero = root.querySelector('.tn-hero');
    var stage = root.querySelector('.tn-hero__stage');
    var canvas = root.querySelector('.tn-hero__canvas');
    var video = root.querySelector('.tn-hero__media');
    var posterLayer = root.querySelector('.tn-hero__poster');
    var ring = root.querySelector('.tn-ring circle');
    var ringWrap = root.querySelector('.tn-ring');
    var bands = Array.prototype.slice.call(root.querySelectorAll('.tn-band'));
    var state = {
      mode: 'none',            /* none | canvas | video | static */
      pinMode: 'start',        /* start | fixed | end | off */
      target: 0, shown: 0, rafId: null, lastTick: 0,
      heroOnScreen: true, loadK: 0, loadRampStart: 0,
      frames: [], framesReady: false, frameDrawn: -1,
      seekBusy: false, pendingTime: null, videoReady: false,
      teardowns: []
    };
    instances[container.id] = { root: root, state: state };

    bands.forEach(function (b, i) {
      splitBand(b, 941 + i * 97);
      b._a = parseFloat(b.dataset.a);
      b._b = parseFloat(b.dataset.b);
      b._op = -1; b._k = -1;
    });

    /* ---------- progress ---------- */
    function heroProgress() {
      var rect = hero.getBoundingClientRect();
      var vh = window.innerHeight;
      var range = rect.height - vh;
      if (range <= 0) return 1;
      return clamp(-rect.top / range, 0, 1);
    }

    /* ---------- caption bands (delta-gated) ---------- */
    function updateCaptions(p, now) {
      var loadK = state.loadK;
      bands.forEach(function (b, idx) {
        var a = b._a, bb = b._b;
        var f = Math.min(0.02, (bb - a) / 3);
        var op = smoothstep(p, a, a + f) * (1 - smoothstep(p, bb - f, bb));
        if (idx === 0) op = 1 - smoothstep(p, bb - f, bb);                 /* first band: no ease-in */
        if (idx === bands.length - 1) op = smoothstep(p, a, a + f);       /* last band: no ease-out */
        var ramp = parseFloat(b.dataset.ramp) || Math.min(0.025, (bb - a) * 0.35);
        var k = clamp((p - a) / ramp, 0, 1);
        if (idx === 0) k = Math.max(k, loadK);                            /* one-time load ramp */
        if (Math.abs(op - b._op) > 0.008) { b._op = op; b.style.opacity = op.toFixed(3); }
        if (Math.abs(k - b._k) > 0.008) { b._k = k; b.style.setProperty('--tn-k', k.toFixed(3)); }
      });
    }

    /* ---------- canvas path (mobile primary) ---------- */
    function sizeCanvas() {
      var dpr = Math.min(2, window.devicePixelRatio || 1);
      var w = canvas.clientWidth || stage.clientWidth, h = canvas.clientHeight || stage.clientHeight;
      if (canvas.width !== Math.round(w * dpr) || canvas.height !== Math.round(h * dpr)) {
        canvas.width = Math.round(w * dpr);
        canvas.height = Math.round(h * dpr);
        state.frameDrawn = -1;
      }
    }
    function drawFrame(i) {
      if (!state.framesReady) return;
      i = clamp(i, 0, state.frames.length - 1);
      if (i === state.frameDrawn) return;
      var img = state.frames[i];
      if (!img) return;
      state.frameDrawn = i;
      var ctx = canvas.getContext('2d');
      var cw = canvas.width, ch = canvas.height;
      var iw = img.width, ih = img.height;
      var s = Math.max(cw / iw, ch / ih);
      var dw = iw * s, dh = ih * s;
      ctx.drawImage(img, (cw - dw) / 2, (ch - dh) / 2, dw, dh);
    }
    function preloadFrames() {
      var urls = cfg.frames;
      var loaded = 0, failed = 0;
      var C = 126;
      return new Promise(function (resolve, reject) {
        if (!urls || !urls.length) { reject(new Error('no frames')); return; }
        state.frames = new Array(urls.length);
        urls.forEach(function (u, i) {
          var img = new Image();
          img.decoding = 'async';
          img.onload = function () {
            state.frames[i] = img; loaded++;
            if (ring) ring.style.strokeDashoffset = Math.round(C * (1 - loaded / urls.length));
            if (loaded + failed === urls.length) (failed ? reject(new Error(failed + ' frames failed')) : resolve());
          };
          img.onerror = function () {
            failed++;
            if (loaded + failed === urls.length) reject(new Error(failed + ' frames failed'));
          };
          img.src = u;
        });
      });
    }

    /* ---------- video path (desktop) ---------- */
    function requestSeek(t) {
      if (!video.duration) return;
      if (state.seekBusy) { state.pendingTime = t; return; }
      state.seekBusy = true;
      video.currentTime = t;
    }
    function onSeeked() {
      state.seekBusy = false;
      if (state.pendingTime !== null) {
        var t = state.pendingTime; state.pendingTime = null; requestSeek(t);
      }
    }
    function onVideoError() { state.seekBusy = false; state.pendingTime = null; }
    video.addEventListener('seeked', onSeeked);
    video.addEventListener('error', onVideoError);
    state.teardowns.push(function () {
      video.removeEventListener('seeked', onSeeked);
      video.removeEventListener('error', onVideoError);
    });

    function loadHeroBlob() {
      var ctrl = new AbortController();
      var watchdog = setTimeout(function () { ctrl.abort(); }, 20000);
      var C = 126;
      return fetch(cfg.videoUrl, { priority: 'low', signal: ctrl.signal }).then(function (res) {
        if (!res.ok) throw new Error('http ' + res.status);
        var total = Number(res.headers.get('Content-Length')) || cfg.videoBytes || 4000000;
        var reader = res.body.getReader();
        var chunks = [], got = 0, lastRing = 0;
        function pump() {
          return reader.read().then(function (r) {
            if (r.done) return;
            clearTimeout(watchdog);
            watchdog = setTimeout(function () { ctrl.abort(); }, 20000);
            chunks.push(r.value); got += r.value.length;
            var frac = Math.min(1, got / total);
            var now = performance.now();
            if (ring && (now - lastRing > 100 || frac === 1)) {
              lastRing = now;
              ring.style.strokeDashoffset = Math.round(C * (1 - frac));
            }
            return pump();
          });
        }
        return pump().then(function () {
          clearTimeout(watchdog);
          if (ring) ring.style.strokeDashoffset = 0;
          video.src = URL.createObjectURL(new Blob(chunks, { type: 'video/mp4' }));
          video.load();
          video.addEventListener('canplay', function () {
            state.videoReady = true;
            requestSeek(heroProgress() * video.duration);
            stage.classList.add('tn-video-ready');
          }, { once: true });
        });
      });
    }

    /* ---------- the rAF loop that rests ---------- */
    function tick(now) {
      var dt = Math.min(100, now - (state.lastTick || now));
      state.lastTick = now;
      var k = 0.16;
      state.shown += (state.target - state.shown) * (1 - Math.pow(1 - k, dt / 16.667));
      var converged = Math.abs(state.target - state.shown) < 0.0005;
      var ramping = state.loadK < 1;
      if (ramping) {
        state.loadK = clamp((now - state.loadRampStart) / 1400, 0, 1);
        state.loadK = state.loadK * state.loadK * (3 - 2 * state.loadK);
      }
      if (converged && !ramping) {
        state.shown = state.target; state.rafId = null; state.lastTick = 0;
      } else {
        state.rafId = requestAnimationFrame(tick);
      }
      if (state.mode === 'canvas' && state.framesReady) {
        drawFrame(Math.round(state.shown * (state.frames.length - 1)));
      } else if (state.mode === 'video' && state.videoReady) {
        requestSeek(state.shown * video.duration);
      }
      updateCaptions(state.shown, now);
      updateDividers(state.shown);
    }
    function wake() {
      if (state.rafId === null && state.heroOnScreen) state.rafId = requestAnimationFrame(tick);
    }
    /* sticky dies inside the theme's overflow:hidden wrappers; pin with fixed instead */
    function updatePin() {
      if (state.mode === 'static') {
        if (state.pinMode !== 'off') {
          state.pinMode = 'off';
          root.classList.remove('tn-pin-fixed', 'tn-pin-end');
        }
        return;
      }
      var r = hero.getBoundingClientRect();
      var vh = window.innerHeight;
      var m = (r.top <= 0 && r.bottom >= vh) ? 'fixed' : (r.bottom < vh ? 'end' : 'start');
      if (m !== state.pinMode) {
        state.pinMode = m;
        root.classList.toggle('tn-pin-fixed', m === 'fixed');
        root.classList.toggle('tn-pin-end', m === 'end');
      }
    }
    function onScroll() { updatePin(); state.target = heroProgress(); wake(); }
    function onResize() { updatePin(); if (state.mode === 'canvas') { sizeCanvas(); drawFrame(state.frameDrawn === -1 ? 0 : state.frameDrawn); } state.target = heroProgress(); wake(); }

    /* ---------- scroll-drawn dividers ---------- */
    var dividers = Array.prototype.slice.call(container.querySelectorAll('.tn-divider path'));
    dividers.forEach(function (p) {
      var len = p.getTotalLength();
      p.style.setProperty('--tn-dash', len);
      p.style.setProperty('--tn-dashoff', len);
      p._len = len; p._drawn = -1;
    });
    function updateDividers() {
      dividers.forEach(function (p) {
        var r = p.closest('svg').getBoundingClientRect();
        var vh = window.innerHeight;
        var vis = clamp((vh - r.top) / (vh * 0.6), 0, 1);
        if (Math.abs(vis - p._drawn) > 0.01) {
          p._drawn = vis;
          p.style.setProperty('--tn-dashoff', Math.round(p._len * (1 - vis)));
        }
      });
    }

    /* ---------- mode gates, decided live ---------- */
    var MQ_REDUCE = matchMedia('(prefers-reduced-motion: reduce)');
    var MQ_PHONE = matchMedia('(max-width: 720px)');
    var MQ_TABP = matchMedia('(orientation: portrait) and (max-width: 1024px)');
    var MQ_COARSEP = matchMedia('(orientation: portrait) and (pointer: coarse)');
    var MQ_LANDPHONE = matchMedia('(orientation: landscape) and (pointer: coarse) and (max-height: 560px)');
    var mqs = [MQ_REDUCE, MQ_PHONE, MQ_TABP, MQ_COARSEP, MQ_LANDPHONE];

    function hostileConnection() {
      var c = navigator.connection;
      if (!c) return false;
      return !!c.saveData || /(^|-)2g/.test(c.effectiveType || '');
    }

    function paintPoster() {
      if (cfg.posterUrl && !posterLayer.style.backgroundImage) {
        posterLayer.style.backgroundImage = 'url("' + cfg.posterUrl + '")';
      }
    }

    function goStatic() {
      if (state.mode === 'static') return;
      state.mode = 'static';
      root.classList.add('tn-static');
      posterLayer.style.backgroundImage = 'url("' + (cfg.endingUrl || cfg.posterUrl) + '")';
      updatePin();
      if (state.rafId !== null) { cancelAnimationFrame(state.rafId); state.rafId = null; }
      document.removeEventListener('scroll', onScroll, { capture: true });
      if (ringWrap && ringWrap.parentNode) ringWrap.replaceWith(makeChevron());
      bands.forEach(function (b) { b.style.opacity = 0; });
    }

    function armScrub(mode) {
      var was = state.mode;
      state.mode = mode;
      root.classList.remove('tn-static');
      if (cfg.posterUrl) posterLayer.style.backgroundImage = 'url("' + cfg.posterUrl + '")';
      if (was === 'none') {
        state.loadRampStart = performance.now();
        if (mode === 'canvas') {
          sizeCanvas();
          preloadFrames().then(function () {
            state.framesReady = true;
            stage.classList.add('tn-canvas-ready');
            if (ringWrap) ringWrap.style.opacity = 0;
            drawFrame(Math.round(heroProgress() * (state.frames.length - 1)));
          }).catch(goStatic);
        } else {
          var posterImg = new Image();
          var started = false;
          var startFetch = function () {
            if (started) return; started = true;
            loadHeroBlob().catch(goStatic);
          };
          posterImg.onload = startFetch; posterImg.onerror = startFetch;
          if (cfg.posterUrl) { posterImg.src = cfg.posterUrl; } else { startFetch(); }
          setTimeout(startFetch, 4000);
        }
      }
      bands.forEach(function (b) { b._op = -1; b._k = -1; });
      document.addEventListener('scroll', onScroll, { passive: true, capture: true });
      updatePin();
      state.target = heroProgress();
      wake();
    }

    function applyMode() {
      if (MQ_REDUCE.matches || hostileConnection()) { goStatic(); return; }
      if (MQ_LANDPHONE.matches) { goStatic(); return; }
      var phoneish = MQ_PHONE.matches || MQ_TABP.matches || MQ_COARSEP.matches;
      /* once a path has loaded its assets, a resize between phone/desktop keeps it: re-arm only from none/static */
      if (state.mode === 'canvas' || state.mode === 'video') { armScrub(state.mode); return; }
      /* desktop without an external video URL rides the frame sequence too */
      armScrub(phoneish || !cfg.videoUrl ? 'canvas' : 'video');
    }
    mqs.forEach(function (m) { m.addEventListener('change', applyMode); });
    state.teardowns.push(function () { mqs.forEach(function (m) { m.removeEventListener('change', applyMode); }); });

    /* ---------- observers ---------- */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { state.heroOnScreen = e.isIntersecting; if (e.isIntersecting) wake(); });
    });
    io.observe(hero);
    state.teardowns.push(function () { io.disconnect(); });

    var fxIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('tn-in');
        fxIo.unobserve(e.target);
        if (e.target.classList.contains('tn-stagger')) {
          setTimeout(function () { e.target.classList.add('tn-settled'); }, 1400);
        }
      });
    }, { threshold: 0.18 });
    container.querySelectorAll('.tn-fx,.tn-stagger').forEach(function (el) { fxIo.observe(el); });
    state.teardowns.push(function () { fxIo.disconnect(); });

    /* ---------- pause everything on hidden tab ---------- */
    function onVis() { root.classList.toggle('tn-paused', document.hidden); }
    document.addEventListener('visibilitychange', onVis);
    state.teardowns.push(function () { document.removeEventListener('visibilitychange', onVis); });

    /* ---------- the tune-in hold moment ---------- */
    var tune = container.querySelector('.tn-tune');
    if (tune) {
      var holdBtn = tune.querySelector('.tn-tune__hold .tn-btn');
      var tuneVal = 0, tuneRaf = null, holding = false, tuned = false;
      var setTune = function (v) {
        tune.style.setProperty('--tn-tune', v.toFixed(3));
        var st = tune.querySelector('.tn-tune__static');
        if (st) st.style.opacity = (1 - v).toFixed(3);
      };
      var tuneStep = function () {
        tuneRaf = null;
        if (tuned) return;
        tuneVal = clamp(tuneVal + (holding ? 0.022 : -0.03), 0, 1);
        setTune(tuneVal);
        if (tuneVal >= 1) {
          tuned = true;
          tune.classList.add('tn-tuned');
          if (holdBtn) holdBtn.textContent = holdBtn.dataset.done || holdBtn.textContent;
          return;
        }
        if (tuneVal > 0 || holding) tuneRaf = requestAnimationFrame(tuneStep);
      };
      var startHold = function (ev) { if (tuned) return; ev.preventDefault(); holding = true; if (tuneRaf === null) tuneRaf = requestAnimationFrame(tuneStep); };
      var endHold = function () { holding = false; };
      if (holdBtn) {
        if (MQ_REDUCE.matches) {
          tuned = true; setTune(1); tune.classList.add('tn-tuned');
          if (holdBtn.dataset.done) holdBtn.textContent = holdBtn.dataset.done;
        } else {
          holdBtn.addEventListener('pointerdown', startHold);
          holdBtn.addEventListener('pointerup', endHold);
          holdBtn.addEventListener('pointercancel', endHold);
          holdBtn.addEventListener('pointerleave', endHold);
          holdBtn.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') startHold(e); });
          holdBtn.addEventListener('keyup', endHold);
        }
      }
    }

    /* ---------- reduced motion flips, both directions ---------- */
    function onReduceFlip(e) {
      if (e.matches) {
        goStatic();
        dividers.forEach(function (p) { p.style.setProperty('--tn-dashoff', 0); });
        container.querySelectorAll('.tn-fx,.tn-stagger').forEach(function (el) { el.classList.add('tn-in', 'tn-settled'); });
        if (tune) {
          tune.classList.add('tn-tuned');
          tune.style.setProperty('--tn-tune', 1);
          var st = tune.querySelector('.tn-tune__static'); if (st) st.style.opacity = 0;
        }
      } else {
        state.mode = 'none';
        root.classList.remove('tn-static');
        applyMode();
      }
    }
    MQ_REDUCE.addEventListener('change', onReduceFlip);
    state.teardowns.push(function () { MQ_REDUCE.removeEventListener('change', onReduceFlip); });

    window.addEventListener('resize', onResize);
    state.teardowns.push(function () {
      window.removeEventListener('resize', onResize);
      document.removeEventListener('scroll', onScroll, { capture: true });
      if (state.rafId !== null) cancelAnimationFrame(state.rafId);
    });

    applyMode();
    updateCaptions(heroProgress());
  }

  function teardownSection(container) {
    var inst = instances[container.id];
    if (!inst) return;
    inst.state.teardowns.forEach(function (fn) { try { fn(); } catch (e) { /* noop */ } });
    delete instances[container.id];
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-tn-hero-section]').forEach(initSection);
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var c = e.target.querySelector('[data-tn-hero-section]') || (e.target.matches && e.target.matches('[data-tn-hero-section]') ? e.target : null);
    if (c) teardownSection(c);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
})();
